export default "__VITE_ASSET__BRRQT7O9__"